import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HrmsService } from '../../../services/hrms.service';

@Component({
  selector: 'app-operation-component',
  standalone: true,
  imports: [SharedModule, CommonModule, FormsModule],
  templateUrl: './operation-component.component.html',
  styleUrls: ['./operation-component.component.scss']
})
export class OperationComponent implements OnInit {

  constructor(
    private router: Router,
    private hrmsService: HrmsService
  ) {}

  pendingLeaveCount: number = 0;
  searchText: string = '';
  pendingAttendanceCount: number = 0;
  expensePendingCount: number = 0;

  services = [

    { 
      name: 'Onboarding', 
      icon: 'pi pi-id-card', 
      color: '#f5b800',
      action: () => this.router.navigate(['/home/onboard'])
      
    },
        { 
        name: 'Employee Engagement', 
        icon: 'pi pi-users', 
        color: '#ec4899',
        action: () => this.router.navigate(['/home/emp-engagement'])
        },

         { 
          name: 'File', 
          icon: 'pi pi-folder', 
          color: '#60a5fa' ,
          action: () => this.router.navigate(['/home/files'])
         },
 
          { 
            name: 'Assets', 
            icon: 'pi pi-database', 
            color: '#f59e0b',
            action: () => this.router.navigate(['/home/assets'])
          },


    {
      name: 'Employee Information',
      icon: 'pi pi-id-card',
      color: '#f5b800',
      action: () => this.router.navigate(['/home/employee-info'])
    },
    {
      name: 'Leave Tracker',
      icon: 'pi pi-sun',
      color: '#0ea5e9',
      action: () => this.router.navigate(['/home/leave-tracker'])
    },
    {
      name: 'Location Management',
      icon: 'pi pi-map-marker',
      color: '#60a5fa',
      action: () => this.router.navigate(['/home/location-management'])
    },
    {
      name: 'Attendance Approval',
      icon: 'pi pi-check-circle',
      color: '#38bdf8',
      action: () => this.router.navigate(['/home/attendance-approval'])
    },
    {
      name: 'Attendance',
      icon: 'pi pi-calendar',
      color: '#f97316',
      action: () => this.router.navigate(['/home/listattendance-tracker'])
    },
    {
      name: 'Shift',
      icon: 'pi pi-clock',
      color: '#38bdf8',
      action: () => this.router.navigate(['/home/list-shift'])
    },
    { name: 'Time Tracker', icon: 'pi pi-stopwatch', color: '#facc15' },
    { name: 'Performance', icon: 'pi pi-star-fill', color: '#22c55e' },
   
    //{ name: 'Employee Engagement', icon: 'pi pi-users', color: '#ec4899' },
    { name: 'HR Letters', icon: 'pi pi-star', color: '#fb923c' },
    { name: 'Tasks', icon: 'pi pi-check-circle', color: '#f97316' },
    
    {
      name: 'Expense & Reimbursement',
      icon: 'pi pi-wallet',
      color: '#14b8a6',
      action: () => this.router.navigate(['/home/expense'])
    },
    //{ name: 'Offboarding', icon: 'pi pi-sign-out', color: '#ef4444' },
    { name: 'Offboarding', 
      icon: 'pi pi-sign-out',
       color: '#ef4444',
       action: () => this.router.navigate(['/home/offboarding'])},
  ];

  ngOnInit(): void {
    this.getPendingLeaveCount();
    this.getPendingAttendanceCount();
    this.loadExpensePendingCount();
    document.title = 'Operations';
  }

  get filteredServices() {
    return this.services.filter(service =>
      service.name.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  getPendingLeaveCount(): void {
    const pageRequest = { pageIndex: 0, pageSize: 100, id: 0 };
    this.hrmsService.getLeave(pageRequest).subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : res?.leaves || [];
        this.pendingLeaveCount = data.filter((leave: any) => leave.status === 'Pending').length;
      },
      error: (err) => console.error('Failed to fetch leave list:', err)
    });
  }

  getPendingAttendanceCount(): void {
    this.hrmsService.getPendingApprovals().subscribe({
      next: (data: any[]) => {
        this.pendingAttendanceCount = (data || []).length;
      },
      error: (err) => console.error('Failed to fetch attendance approvals:', err)
    });
  }
  loadExpensePendingCount(): void {
    this.hrmsService.getExpenseReimbursement({ pageIndex: 0, pageSize: 1000 }).subscribe({
      next: (res: any) => {
        const list: any[] = res?.expenses || res || [];
        this.expensePendingCount = list.filter(
          (x: any) => x.status === 'Pending' || x.status === 'Submitted'
        ).length;
      },
      error: (err) => console.error(err)
    });
  }

}
